module.exports = __webpack_public_path__ + "img/about-fosun-zhCn.6c983e80.png";